import {EntityContact} from "./EntityContact.jsx";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";

export class TaskContact extends EntityContact {
  static get $name() {
    return "TaskContact";
  }

  static relations = {
    taskRecord: { // this will get task record of this record
      foreignKey: "taskId",
      foreignStore: STORE_KEYS.taskStore,
      relatedCollectionName: "contacts", // this key will be added to the parent to get child records -> taskStore.first.contacts will bring all TaskContact records for that task record
    },
    contactRecord: { // this will get contact (detail) record of this record
      foreignKey: "contactId",
      foreignStore: STORE_KEYS.contactStore,
      relatedCollectionName: "taskContacts", // this key will be added to the parent to get child records -> contactStore.first.taskContacts will bring all TaskContact records for that contact record
    }
  }

  static get fields() {
    return [
      { name: "taskId", dataSource: "task" },
    ];
  }
}

TaskContact.exposeProperties();
